import React, { Component, useEffect } from 'react';
import { connect } from 'react-redux';
import { withStyles } from "@material-ui/core";
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Paper from '@mui/material/Paper';
import HistoryListitem from './HistoryListitem';
import AWS from 'aws-sdk';
import config from '../../../../config.json';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Divider from "@mui/material/Divider";


const useStyles = (theme) => ({

    container: {
        height: '500',
    },

    item: {
        width: '30%',
        height: '500',
        padding: 24
    },

    divider: {
        height: '100vh',
        width: 1,
        backgroundColor: '#c5cae9'
    },

});



class HistoryView_ extends Component {

    constructor(props) {
        super(props);

        this.state = {
            simulations: []
        };

    }

    componentDidMount() {
        AWS.config.update({
            accessKeyId: config.accessKeyId,
            secretAccessKey: config.secretAccessKey,
            region: config.region
        });

        const s3 = new AWS.S3();
        const params = { Bucket: 'testbucket-516579854', Prefix: 'history/' };

        s3.listObjectsV2(params, (err, data) => {
            if (err) {
                console.error('Error connecting to S3:', err);
                return;
            }

            console.log('S3 data:', data);

            const simulations = data.Contents.filter(obj => obj.Key.endsWith('.json')).map(obj => {
                const key = obj.Key.replace('history/', '');
                const simulationFolder = key.split('/')[0];
                const stlObjects = data.Contents.filter(obj => obj.Key.startsWith(`history/${simulationFolder}/`) && obj.Key.endsWith('.stl'));
                const stlFileNames = stlObjects.map(obj => obj.Key.split('/')[2]);
                return {
                    folder: simulationFolder,
                    jsonFileName: obj.Key.split('/')[2],
                    stlFileNames: stlFileNames,
                    date: obj.LastModified
                }
            });
            console.log('Simulations:', simulations);
            this.setState({ simulations });
        });
    }



    render() {

        const { classes } = this.props;
        const { simulations } = this.state;

        return (

            <Grid
                container
                direction="column"
                justifyContent="flex-start"
                alignItems="stretch"
                spacing={1}
                height="100vh" >

                <Box sx={{ flexGrow: 1, m: 2, display: "flex", flexDirection: "row", ml: 5, mt: 5 }}>

                    <Grid
                        container
                        direction={'column'}
                        alignItems="left"
                        justifyContent="left" >


                        <Grid
                            container
                            height="7vh"
                            direction={'row'}
                            alignItems="left"
                            justifyContent="left" >

                            <Typography
                                sx={{ mt: 0, mb: 1 }}
                                variant="h5"
                                color="primary"
                                component="div">
                                Recent Simulations
                            </Typography>

                        </Grid>


                    

                        <Box overflow="auto" sx={{ flexGrow: 1, maxHeight: '100vh', marginTop: 3 }}>
                            <Grid container direction="row" justifyContent="flex-start" alignItems="stretch" sx={{ mt: 1 }} spacing={1} sx={{
                                display: 'flex',
                                flexWrap: 'wrap',
                                '& > *': {
                                    flex: '1 1 auto',
                                    minWidth: '400px',
                                    maxWidth: '400px',
                                    height: 'auto',
                                    margin: '5px',
                                },
                            }}>
                                {simulations.length > 0 ? (
                                    simulations.map((simulation, index) => (
                                        <HistoryListitem key={index} simulation={simulation} />
                                    ))
                                ) : (
                                    <Typography color="secondary" sx={{ mt: 0, mb: 1, ml: 1 }} variant="h6">
                                        No Simulations Found
                                    </Typography>
                                )}
                            </Grid>
                        </Box>


                    </Grid>

                </Box>


            </Grid>

        );

    }

}


const mapStateToProps = (state, props) => {

    return {
    };

}

const mapDispatchToProps = (dispatch, props) => {

    return {
    };

}


const HistoryView = connect(mapStateToProps, mapDispatchToProps)(HistoryView_)
export default withStyles(useStyles)(HistoryView);